<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar
          flat
          color="white"
        >
          <v-row
            class="fill-height"
            justify="space-between"
          >
            <v-col cols="4">
              <v-select
                :items="filters"
                :item-text="(filter) => `${filter.text}`"
                :item-value="(filter) => `${filter.value}`"
                v-model="filter"
                @change="items = []"
                outlined
                dense
              >
                <template #label>
                  <span>Filter By</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :items="filterItems"
                :item-text="(filter) => `${filter.text}`"
                :item-value="(filter) => `${filter.value}`"
                v-model="items"
                outlined
                dense
                multiple
              >
                <template #label>
                  <span>{{ getCurrentSelectionItem() }}</span>
                </template>
                <template #selection="{ item, index }">
                  <span v-if="index === 0">
                    <span>{{ `${item.text} ` }}</span>
                  </span>
                  <span
                    v-if="index === 1"
                    class="grey--text caption"
                  >
                    &nbsp;(+{{ items.length - 1 }} others)
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                Today
              </v-btn>
              <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prev"
              >
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="next"
              >
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <span
                class="mr-5"
                v-if="$refs.calendar"
              >
                {{ $refs.calendar.title }}
              </span>
              <v-menu bottom>
                <template #activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-toolbar>
      </v-sheet>
      <v-sheet>
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="filteredEvents"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        >
          <template #event="{ event }">
            <span class="mx-2">{{ handleEvent(event) }}</span>
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="white"
                  v-if="event.recurring == '1'"
                  class="float-right mr-2"
                >
                  mdi-sync
                </v-icon>
              </template>
              <span>Recurring</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="event.color == 'purple'"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="white"
                  class="float-right mr-2"
                >
                  mdi-card-text
                </v-icon>
              </template>
              <span>{{ event.name }}</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="event.color == 'pink'"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="white"
                  class="float-right mr-2"
                >
                  mdi-bike
                </v-icon>
              </template>
              <span>{{ event.name }}</span>
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="event.color == '#914f07'"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  color="white"
                  class="float-right mr-2"
                >
                  mdi-briefcase-account-outline
                </v-icon>
              </template>
              <span>{{ event.name }}</span>
            </v-tooltip>
          </template>
        </v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
          v-if="isShared"
        >
          <v-card
            min-width="350px"
            flat
            max-height="500"
          >
            <v-toolbar
              dark
              flat
              :color="selectedEvent.color"
            >
              <v-btn icon>
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
              <v-toolbar-title> {{ handleColorInfo(selectedEvent) }}</v-toolbar-title>
              <v-spacer />

              <template #extension>
                <v-tabs
                  v-model="model"
                  centered
                  slider-color="#914f07"
                >
                  <v-tab
                    href="#information"
                  >
                    Information Detail
                  </v-tab>
                  <v-tab
                    href="#passenger"
                  >
                    Passenger Info
                  </v-tab>
                </v-tabs>
              </template>
            </v-toolbar>

            <v-tabs-items v-model="model">
              <v-tab-item
                value="information"
              >
                <div class="pa-5">
                  <div class="my-2">
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-car
                    </v-icon>
                    <span v-html="selectedEvent.name" />
                  </div>
                  <div class="my-2">
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-timer-sand
                    </v-icon>
                    {{ getStartDateTime(selectedEvent) }}
                  </div>
                  <div class="my-2">
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-map-marker
                    </v-icon>
                    From
                    <b>
                      {{ getOriginName(selectedEvent) }}
                    </b>
                    To
                    <b>
                      <span v-if="getDestinationAddr(selectedEvent)">{{ getDestinationAddr(selectedEvent) }}</span>
                    </b>
                  </div>
                  <div class="my-2">
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-calendar-clock
                    </v-icon>
                    {{ getDates(selectedEvent) }}
                  </div>
                  <div class="my-2">
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-clock-time-three-outline
                    </v-icon>
                    {{ getDuration(selectedEvent) }}
                  </div>
                  <div
                    class="my-2"
                    v-if="showCostCode(selectedEvent)"
                  >
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-currency-usd
                    </v-icon>
                    {{ getCostCode(selectedEvent) }}
                  </div>
                  <div
                    class="my-2"
                    v-show="isRecurring"
                  >
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-sync
                    </v-icon>
                    {{ getRecurring(selectedEvent) }}
                  </div>
                  <div class="my-2">
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-map
                    </v-icon>
                    Car Park Location: {{ getCarParkLocation(selectedEvent) }}
                  </div>
                  <div class="my-2 ">
                    <v-icon
                      :color="selectedEvent.color"
                      left
                    >
                      mdi-key
                    </v-icon>
                    Key Cabinet Location: {{ getKeCabinetLocation(selectedEvent) }}
                  </div>
                </div>

                <v-card-actions>
                  <v-btn
                    text
                    :color="selectedEvent.color"
                    @click="selectedOpen = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-tab-item>
              <v-tab-item
                value="passenger"
              >
                <v-simple-table class="ma-5 blue lighten-5">
                  <template #default>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Booked By</th>
                        <th>Passenger</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(share, i) in shared"
                        :key="share.id"
                      >
                        <td>
                          {{ i + 1 }}
                        </td>
                        <td>
                          {{
                            `${share.name}`
                          }}
                          <v-chip
                            x-small
                            class="ma-2"
                            color="primary"
                            dark
                            v-if="share.is_owner"
                          >
                            Owner
                          </v-chip>
                        </td>
                        <td>{{ share.passenger_count }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-menu>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
          v-if="!isShared"
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            flat
          >
            <div class="pa-5">
              <div class="my-2">
                <v-icon
                  :color="selectedEvent.color"
                  left
                >
                  mdi-account
                </v-icon>
                {{ selectedEvent.user_name }} ( {{ selectedEvent.passenger_count }} Passenger )
              </div>
              <div class="my-2">
                <v-icon
                  :color="selectedEvent.color"
                  left
                >
                  mdi-car
                </v-icon>
                {{ selectedEvent.name }}
              </div>
              <div class="my-2">
                <v-icon
                  :color="selectedEvent.color"
                  left
                >
                  mdi-timer-sand
                </v-icon>
                {{ getStartDateTime(selectedEvent) }}
              </div>
              <div class="my-2">
                <v-icon
                  :color="selectedEvent.color"
                  left
                >
                  mdi-map-marker
                </v-icon>
                From
                <b>
                  {{ getOriginName(selectedEvent) }}
                </b>
                To
                <b>
                  <span v-if="getDestinationAddr(selectedEvent)">{{ getDestinationAddr(selectedEvent) }}</span>
                </b>
              </div>
              <div class="my-2">
                <v-icon
                  :color="selectedEvent.color"
                  left
                >
                  mdi-calendar-clock
                </v-icon>
                {{ getDates(selectedEvent) }}
              </div>
              <div class="my-2">
                <v-icon
                  :color="selectedEvent.color"
                  left
                >
                  mdi-clock-time-three-outline
                </v-icon>
                {{ getDuration(selectedEvent) }}
              </div>
              <div
                class="my-2"
                v-show="isRecurring"
              >
                <v-icon
                  :color="selectedEvent.color"
                  left
                >
                  mdi-sync
                </v-icon>
                {{ getRecurring(selectedEvent) }}
              </div>
            </div>

            <v-card-actions>
              <v-btn
                text
                :color="selectedEvent.color"
                @click="selectedOpen = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <div class="mt-4">
          <v-card
            class="d-flex mb-3"
            color="transparent"
            flat
          >
            <v-card
              v-for="legend in legendItems"
              :key="legend.color"
              tile
              elevation="0"
              class="d-flex pa-2"
            >
              <v-sheet
                :color="legend.color"
                width="15"
                class="mx-2 mt-1"
                height="15"
              />
              <span
                class="m1-1"
                style="font-size: 14px"
              >{{ legend.text }}</span>
            </v-card>
          </v-card>
        </div>
      </v-sheet>
    </v-col>
    <v-overlay :value="overlayCalendar">
      <v-progress-circular
        indeterminate
        color="gray"
        size="64"
      />
    </v-overlay>
  </v-row>
</template>

<script>
/* eslint-disable */

  import moment from 'moment'
  import isEmpty from 'lodash/isEmpty'
  import isNull from 'lodash/isNull'
  import isUndefined from 'lodash/isUndefined'
  import get from 'lodash/get'
  import includes from 'lodash/includes'
  import capitalize from 'lodash/capitalize'
  const qs = require('qs')


  export default {
    data() {
      return {
        focus: '',
        type: 'month',
        typeToLabel: {
          month: 'Month',
          week: 'Week',
          day: 'Day',
          '4day': '4 Days',
        },
        model: 'information',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        address: '',
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        isShared: false,
        address: '',
        events: [],
        shared: [],
        colors: ['blue', 'indigo', 'purple', 'cyan', 'green', 'orange'],
        names: [],
        schedulesData: {},
        overlayCalendar: false,
        filters: [
          {
            text: 'Vehicle',
            value: 'vehicle'
          },
          {
            text: 'Origin',
            value: 'origin'
          },
          {
            text: 'Popular Destination',
            value: 'destination'
          }
        ],
        filter: 'vehicle',
        items: '',
        isRecurring: false,
        assetTypes: [],
        legendItems: [
          {
            text: 'Waiting For Approval',
            color: 'orange'
          },
          {
            text: 'My Booking',
            color: 'green'
          },
          {
            text: 'Sharing Ride (Share rider)',
            color: 'blue'
          },
          {
            text: 'Sharing Ride (Share owner)',
            color: 'cyan'
          },
          {
            text: 'Other User Booking',
            color: 'light-green'
          },
          {
            text: 'Booking E-bike',
            color: 'pink'
          },
          {
            text: 'Booking Myki',
            color: 'purple'
          },
          {
            text: 'Booking Other Asset',
            color: '#914f07'
          },

        ],
        getVehicles: [],
      };
    },
    mounted() {
      this.getAssetType()
      this.getDataVehicles()
      this.$refs.calendar.checkChange()
      this.$store.dispatch('LOAD_TIMEZONES')
      this.$store.dispatch('LOAD_POOL_DATA')
      this.$store.dispatch('LOAD_DESTINATION_DATA')
    },
    computed: {
      userData() {
        const userData = this.$store.getters.getUserData
        return userData.user
      },
      userType() {
        return this.userData.type
      },
      timezones() {
        return this.$store.getters.getTimezones
      },
      getPoolData() {
        return this.$store.getters.getPoolData
      },
      getDestinationData() {
        return this.$store.getters.getDestinationData
      },
      filteredEvents() {
        const events = this.events.filter(event => {
          let display = true;
          if (this.items.length) {
            switch (this.filter) {
              case 'vehicle':
                display = includes(this.items, event.vehicle_id)
                break;
              case 'origin':
                display = includes(this.items, event.from)
                break;
              case 'destination':
                let metadata = {}
                try {
                  metadata = JSON.parse(event.metadata)
                } catch(e) {}
                if (metadata.hasOwnProperty('address')) {
                  display = includes(this.items, metadata.address)
                } else {
                  display = false
                }
                break;
              default:

            }
          }

          return display;
        })
        return events;
      },
      filterItems() {
        const items = []

        this.events.map(event => {
          const item = {
            text: '',
            value: ''
          }

          switch (this.filter) {
            case 'vehicle':
              item.text = event.name
              item.value = event.vehicle_id
            break;
            case 'destination':
              let metadata = {}
              try {
                metadata = JSON.parse(event.metadata)
              } catch(e) {}
              if (metadata.hasOwnProperty('address')) {
                item.text = metadata.address
                item.value = metadata.address
              }
              break;
            case 'origin':
              item.text = this.getOriginName(event)
              item.value = event.from
              break;
            default:
            break;
          }

          if (item.text && item.value) {
            const selectedItem = items.find(i => i.text == item.text && i.value && item.value)
            if (typeof selectedItem == 'undefined') items.push(item);
          }
        })

        return items;
      }
    },
    methods: {
      getDataVehicles() {
        this.token = this.$store.state.token;
        this.clientid = this.$store.state.clientid;
        this.$store.dispatch('API_CALL', {
            $method: 'get_vehicles',
            $postData: {
              clientid: this.clientid,
            },
          })
          .then((response) => {
            this.getVehicles = response.data.data;
          });
      },
      handleColorInfo(event) {
        let name = ""
        if(event.color == "orange") {
          name = "Waiting For Approval"
        } else if (event.color == "green") {
          name = "My Booking"
        } else if (event.color == "blue") {
          name = "Sharing Ride (Share rider)"
        } else if (event.color == "cyan") {
          name = "Sharing Ride (Share owner)"
        } else if (event.color == "light-green") {
          name = "Other User Booking"
        } else if (event.color == "pink") {
          name = "Booking E-bike"
        } else if (event.color == "purple") {
          name = "Booking Myki"
        } else if (event.color == "#914f07") {
          name = `Booking ${event.name}`
        }
        return name
      },
      getAssetType() {
        this.$store.dispatch('API_CALL', {
            $method: 'get_asset_types',
            $postData: {
              clientid: this.$store.state.clientid,
            },
          })
          .then((response) => {
            this.assetTypes = response.data.data;
          });
      },
      handleEvent(event) {
        let start = moment(event.start).format('HH:mm')
        if(event.hasOwnProperty("username")) {
          return `${start} - ${event.username}`
        } else {
          return event.user_name
        }
      },
      getRecurring(data) {
        let recurring = ""
        let recurring_info = get(data.metadata, "recurring_info", {})
        let metadata = ""
        if (typeof data.metadata === "string") {
          metadata = JSON.parse(data.metadata);
          if(!isEmpty(metadata)) {
            if(metadata.hasOwnProperty("recurring_info")) {
              this.isRecurring = true;
              if(metadata.recurring_info.hasOwnProperty("end_after")) {
                recurring = `Recurring ${ metadata.recurring_info.crontab}, ${ metadata.recurring_info.end_after } occurance`;
              } else {
                let end_date = moment(metadata.recurring_info.end_by, 'YYYY-MM-DD')
                recurring = `Recurring ${ metadata.recurring_info.crontab }, End after ${ end_date.format('D MMM YYYY') }`;
              }
            } else {
              recurring = "";
              this.isRecurring = false;
            }
          }
        } else {
            if(!isEmpty(recurring_info)) {
              if(recurring_info.hasOwnProperty("end_after")) {
                recurring = `${data.metadata.recurring_info.crontab}, ${data.metadata.recurring_info.end_after} occurance`;
              } else {
                recurring = `${data.metadata.recurring_info.crontab}`;
              }
            }
        }
        return recurring
      },
      getCarParkLocation(bookDetail) {
        if (bookDetail && bookDetail.vehicle_id) {
          const vehicle = this.getVehicles.find((v) => v.id == bookDetail.vehicle_id);
          if (vehicle) {
            return get(vehicle, 'metadata.parking_location', '');
          }
        }
        return '';
      },
      getKeCabinetLocation(bookDetail) {
        if (bookDetail && bookDetail.vehicle_id) {
          const vehicle = this.getVehicles.find((v) => v.id == bookDetail.vehicle_id);
          if (vehicle) {
            return get(vehicle, 'cabinet_name', '');
          }
        }
        return '';
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getStartDateTime(selectedEvent) {
        const startDate = moment(selectedEvent.start).format('D MMM YYYY')
        const startTime = moment(selectedEvent.start, 'YYYY-MM-DD HH:mm')
        const endTime = moment(selectedEvent.end, 'YYYY-MM-DD HH:mm')
        const duration = moment.duration(endTime.diff(startTime))
        const day = duration.days()
        const hour = duration.hours()

        if (day != 0) {
          return `${startDate}, ${startTime.format('HH:mm A')}, ${day} Days ${hour} Hours`
        } else {
          return `${startDate}, ${startTime.format('HH:mm A')}, ${hour} Hours`
        }
      },
      getOriginName(selectedEvent) {
        if (selectedEvent == null) return
        const metadata = this.getPoolData.find(g => g.Id == selectedEvent.from)
        if (!metadata) return
        return metadata.name
      },
      getDestinationAddr(selectedEvent) {
        if(isEmpty(selectedEvent)){
          return 'loading'
        } else {
          if (selectedEvent.to != 0) {
            const metadata = this.getDestinationData.find(g => g.Id == selectedEvent.to)
            if (!metadata) return
            return metadata.name
          } else {
            const metadata = JSON.parse(selectedEvent.metadata)
            return metadata.address
          }
        }
      },
      getDates(selectedEvent) {
        const start = moment(selectedEvent.start, 'YYYY-MM-DD')
        const end = moment(selectedEvent.end, 'YYYY-MM-DD')
        const duration = moment.duration(end.diff(start))
        const day = duration.days()
        if (day == 0) {
          if (start == moment().format('YYYY-MM-DD')) {
            return 'Today'
          } else {
            return `${start.format('D MMM YYYY')}`
          }
        } else {
          return `${start.format('D')} \u2014 ${end.format('D')} ${start.format('MMM YYYY')}`
        }
      },
      getDuration(selectedEvent) {
        const start = moment(selectedEvent.start).format('HH:mm')
        const end = moment(selectedEvent.end).format('HH:mm')
        return `${start} \u2014 ${end}`
      },
      showCostCode(selectedEvent) {
        let show = false;
        let metadata = {};
        try {
          metadata = JSON.parse(get(selectedEvent, 'metadata', ''));
        } catch(e) {}
        if (metadata.hasOwnProperty('cost_code')) {
          if (metadata.cost_code) {
            show = true;
          }
        }
        return show;
      },
      getCostCode(selectedEvent) {
        let costCode = '';
        let metadata = {};
        try {
          metadata = JSON.parse(get(selectedEvent, 'metadata', ''));
        } catch(e) {}
        if (metadata.hasOwnProperty('cost_code')) {
          if (metadata.cost_code) {
            costCode = metadata.cost_code;
          }
        }
        return costCode;
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          const share = []
          if(!isEmpty(this.selectedEvent.shared)){
            const eventCount = this.selectedEvent.shared.length
            for (let i = 0; i < eventCount; i++) {
              share.push({
                name:`${this.selectedEvent.shared[i].first_name} ${this.selectedEvent.shared[i].last_name}`,
                id: this.selectedEvent.shared[i].id,
                passenger_count: this.selectedEvent.shared[i].passenger_count,
                is_owner: this.selectedEvent.shared[i].is_owner,
              })
            }
            this.shared = share
          } else {
            this.shared = share
           }
          if(!isEmpty(this.selectedEvent.shared)){
            this.isShared = true
          } else {
            this.isShared = false
          }
          this.selectedElement = nativeEvent.target
          setTimeout(() => this.selectedOpen = true, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        this.overlayCalendar = true;
        const events = []
        const startDatetime = start.date + (start.time == '' ? ' 00:00' : start.time)
        const endDatetime   = end.date   + (end.time   == '' ? ' 23:59' : end.time)
        if(this.userType == 2 || this.userType == 4){
          this.getAssetType();
          this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: {
              user_id: this.$store.state.user.user.id,
              clientid: this.$store.state.clientid,
              start_date: `${start.date} 00:00:00`,
              end_date: `${end.date} 23:59:59`,
              get_recurring: 1
            },
          })
          .then(
            (response) => {
              if (response !== null) {
                this.overlayCalendar = false;
                this.schedulesData = response.data.data.filter(booking => booking.book_detail.status == 2 || booking.book_detail.status == 1)
                const schedules     = this.schedulesData.filter((schedule) => {
                  return schedule.book_detail
                })
                const dataBook = schedules.book_detail
                const masterData = schedules.filter((booking) => {
                  if (booking.book_detail.join_with == null) {
                    return true;
                  }
                  return schedules.find(s => s.book_id === booking.book_detail.join_with) === undefined;
                })
                for (let i = 0; i < masterData.length; i++) {
                  masterData[i]['shared'] = masterData[i].book_detail.passenger
                }

                const allDay = this.rnd(0, 3) === 0
                const eventCount = masterData.length
                for (let i = 0; i < eventCount; i++) {
                  if(masterData[i].book_detail.status == '1') {
                     events.push({
                      id: masterData[i].book_detail.id,
                      name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                      start: masterData[i].book_detail.start_datetime,
                      end: masterData[i].book_detail.end_datetime,
                      color: "orange",
                      user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                      username: `${masterData[i].username}`,
                      passenger_count: masterData[i].passenger_count,
                      timed: true,
                      from: masterData[i].book_detail.start_geofence_id,
                      metadata: masterData[i].book_detail.metadata,
                      to: masterData[i].book_detail.end_geofence_id,
                      shared: masterData[i].shared,
                      recurring: masterData[i].book_detail.recurring,
                      vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                    })
                  } else {
                      let currentPassenger = masterData[i].book_detail.passenger.find(p => p.username == this.$store.state.user.user.username)
                      let is_owner = false;
                      if (!isUndefined(currentPassenger)) {
                        if(currentPassenger.is_owner == true || currentPassenger.is_owner == 'true' ) {
                          is_owner = true
                        }
                      }
                      if(masterData[i].shared.length == 1 && !isUndefined(currentPassenger)  && isEmpty(masterData[i].book_detail.asset_id)) {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: "Vehicle  " + masterData[i].book_detail.vehicle_name,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "green",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: masterData[i].book_detail.vehicle_id
                        })
                      } else if(masterData[i].shared.length == 1  && !isEmpty(masterData[i].book_detail.asset_id)){
                        const item = this.assetTypes.find((d) => d.id == masterData[i].book_detail.asset_type);
                        this.overlayCalendar = false;
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: get(item, "name", "-"),
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: get(item, "metadata.calendar_color", "#914f07"),
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: masterData[i].book_detail.asset_number
                        })
                      }
                      else if (masterData[i].shared.length == 1) {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "light-green",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                        })
                      }
                      else if (masterData[i].shared.length > 1 && !isUndefined(currentPassenger) && currentPassenger.is_owner) {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "cyan",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                        })
                      } else {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "blue",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                        })
                      }
                    }
                }
                this.events = events
              }
            }
          )
        } else if (this.userType == 3){
          this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: {
              start_date: `${start.date} 00:00:00`,
              end_date: `${end.date} 23:59:59`,
              get_recurring: 1
            },
          })
          .then(
            (response) => {
              if (response !== null) {
                this.overlayCalendar = false;
                this.schedulesData = response.data.data.filter(booking => booking.book_detail.status == 2)
                const schedules     = this.schedulesData.filter((schedule) => {
                  return schedule.book_detail
                })
                const dataBook = schedules.book_detail
                const masterData = schedules.filter(booking => booking.book_detail.join_with == null)
                for (let i = 0; i < masterData.length; i++) {
                  masterData[i]['shared'] = schedules.filter(booking => booking.book_detail.join_with == masterData[i]['id'] )
                }
                const allDay = this.rnd(0, 3) === 0
                const eventCount = masterData.length
                for (let i = 0; i < eventCount; i++) {
                  events.push({
                    id: masterData[i].book_detail.id,
                    name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                    start: masterData[i].book_detail.start_datetime,
                    end: masterData[i].book_detail.end_datetime,
                    color: !isEmpty(masterData[i].shared) ? "blue" : "green",
                    user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                    timed: true,
                    from: masterData[i].book_detail.start_geofence_id,
                    metadata: masterData[i].book_detail.metadata,
                    to: masterData[i].book_detail.end_geofence_id,
                    shared: masterData[i].shared,
                    vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                  })
                }
                this.events = events
              }
            }
          )
        } else if (this.userType == 1){
          this.getAssetType();
          this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: {
              clientid: this.$store.state.clientid,
              start_date: `${start.date} 00:00:00`,
              end_date: `${end.date} 23:59:59`,
              get_recurring: 1
            },
          })
          .then(
            (response) => {
              if (response !== null) {
                // this.overlayCalendar = false;
                this.schedulesData = response.data.data.filter(booking => booking.book_detail.status == 2 || booking.book_detail.status == 1)
                const schedules     = this.schedulesData.filter((schedule) => {
                  return schedule.book_detail
                })
                const dataBook = schedules.book_detail
                const masterData = schedules.filter((booking) => {
                  if (booking.book_detail.join_with == null) {
                    return true;
                  }
                  return schedules.find(s => s.book_id === booking.book_detail.join_with) === undefined;
                })
                if(!isEmpty(masterData)){
                  for (let i = 0; i < masterData.length; i++) {
                    // masterData[i]['shared'] = schedules.filter(booking => booking.book_detail.join_with == masterData[i]['id'] )
                    masterData[i]['shared'] = masterData[i].book_detail.passenger
                  }
                  const allDay = this.rnd(0, 3) === 0
                  const eventCount = masterData.length
                  for (let i = 0; i < eventCount; i++) {
                    if(masterData[i].book_detail.status == '1') {
                      events.push({
                        id: masterData[i].book_detail.id,
                        name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                        start: masterData[i].book_detail.start_datetime,
                        end: masterData[i].book_detail.end_datetime,
                        color: "orange",
                        user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                        username: `${masterData[i].username}`,
                        timed: true,
                        from: masterData[i].book_detail.start_geofence_id,
                        metadata: masterData[i].book_detail.metadata,
                        to: masterData[i].book_detail.end_geofence_id,
                        shared: masterData[i].shared,
                        passenger_count: masterData[i].passenger_count,
                        recurring: masterData[i].book_detail.recurring,
                        vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                      })
                    } else {
                      let currentPassenger = masterData[i].book_detail.passenger.find(p => p.username == this.$store.state.user.user.username)
                      let is_owner = false;
                      if (!isUndefined(currentPassenger)) {
                        if(currentPassenger.is_owner == true || currentPassenger.is_owner == 'true' ) {
                          is_owner = true
                        }
                      }
                      if(masterData[i].shared.length == 1 && !isUndefined(currentPassenger)  && isEmpty(masterData[i].book_detail.asset_id)) {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: "Vehicle  " + masterData[i].book_detail.vehicle_name,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "green",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: masterData[i].book_detail.vehicle_id
                        })
                      } else if(masterData[i].shared.length == 1 && !isEmpty(masterData[i].book_detail.asset_id)){
                        const item = this.assetTypes.find((d) => d.id == masterData[i].book_detail.asset_type);
                        this.overlayCalendar = false;
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: get(item, "name", "-"),
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: get(item, "metadata.calendar_color", "#914f07"),
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: masterData[i].book_detail.asset_number
                        })
                      }
                      else if (masterData[i].shared.length == 1) {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "light-green",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                        })
                      }
                      else if (masterData[i].shared.length > 1 && !isUndefined(currentPassenger) && currentPassenger.is_owner) {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "cyan",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                        })
                      } else {
                        events.push({
                          id: masterData[i].book_detail.id,
                          name: isEmpty(masterData[i].book_detail.asset_id) ? "Vehicle  " + masterData[i].book_detail.vehicle_name : "Asset  " + masterData[i].book_detail.asset_number,
                          start: masterData[i].book_detail.start_datetime,
                          end: masterData[i].book_detail.end_datetime,
                          color: "blue",
                          user_name: `${masterData[i].first_name} ${masterData[i].last_name}`,
                          username: `${masterData[i].username}`,
                          timed: true,
                          from: masterData[i].book_detail.start_geofence_id,
                          metadata: masterData[i].book_detail.metadata,
                          to: masterData[i].book_detail.end_geofence_id,
                          shared: masterData[i].shared,
                          passenger_count: masterData[i].passenger_count,
                          recurring: masterData[i].book_detail.recurring,
                          vehicle_id: isEmpty(masterData[i].book_detail.asset_id) ? masterData[i].book_detail.vehicle_id : masterData[i].book_detail.asset_number
                        })
                      }
                    }
                  }
                }
                this.events = events
              }
            }
          )
        }

      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      getCurrentSelectionItem() {
        return `Select ${capitalize(this.filter)}`
      }
    },
    watch: {
      overlayCalendar (val) {
        val && setTimeout(() => {
          this.overlayCalendar = false
        }, 2e3)
      },
    }
  }
</script>
<style scoped>
.v-calendar-daily__scroll-area {
    overflow-y: hidden;
}
</style>
